import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { ApiResult } from '../remote-data'
import { TooltipAlignment, TooltipDisplay, TooltipPosition } from '../tooltip'
import { ButtonDetails, TableAction } from './table-action'
import { TooltipDetails } from './table-column'

@Component({
  selector: 'ftr-table-cell-action',
  templateUrl: './table-cell-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellActionComponent<TInput, TResult> implements OnInit {
  readonly tooltipPosition = TooltipPosition
  readonly tooltipAlignment = TooltipAlignment
  readonly tooltipDisplay = TooltipDisplay

  @Input()
  data: TInput

  @Input()
  tableAction: TableAction<TInput, TResult>

  button: ButtonDetails | undefined
  isActionShown: boolean
  action: () => ApiResult<TResult>
  tooltip: TooltipDetails | undefined

  ngOnInit(): void {
    this.action = () => this.tableAction.actionFn(this.data)
    this.button = this.tableAction.button
    this.isActionShown = this.tableAction.showAction(this.data)
    this.tooltip = this.tableAction.tooltipFn(this.data)
  }

  protected readonly TooltipDisplay = TooltipDisplay
  protected readonly TooltipPosition = TooltipPosition
  protected readonly TooltipAlignment = TooltipAlignment
}
